var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    staticClass: "iq-card-block iq-card-stretch iq-card-height text-center"
  }, [[_c('div', {
    staticClass: "btn-group w-100"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary p-3 btn-menu",
    class: {
      'btn-menu-active': _vm.viewMenu === 'plan'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.viewMenu = 'plan';
      },
      "mouseover": function mouseover($event) {
        _vm.tabMenuOptions.plan.isHover = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.tabMenuOptions.plan.isHover = false;
      }
    }
  }, [_vm._v(" PLAN MAINTENANCE "), _c('MaintenanceListIcon', {
    staticClass: "ml-2",
    attrs: {
      "color": _vm.tabMenuOptions.plan.isHover || _vm.viewMenu === 'plan' ? 'white' : '#0088AF'
    }
  })], 1), _c('button', {
    staticClass: "btn btn-outline-primary p-3 btn-menu",
    class: {
      'btn-menu-active': _vm.viewMenu === 'history'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.viewMenu = 'history';
      },
      "mouseover": function mouseover($event) {
        _vm.tabMenuOptions.history.isHover = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.tabMenuOptions.history.isHover = false;
      }
    }
  }, [_vm._v(" MAINTENANCE HISTORY "), _c('MaintenanceHistoryIcon', {
    staticClass: "ml-2",
    attrs: {
      "color": _vm.tabMenuOptions.history.isHover || _vm.viewMenu === 'history' ? 'white' : '#0088AF'
    }
  })], 1)])]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.viewMenu === 'plan' ? [_c('MaintenancePlan')] : _vm._e(), _vm.viewMenu === 'history' ? [_c('MaintenanceHistoryNew')] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }